import React, { useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import classNames from "classnames";

export const JonusExperienceScroll = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(1);
  var settings = {
    autoplay: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: false,
    // fade: true,
    beforeChange: (old, newIndex) => {
      console.log(old, newIndex);
      if (old === 3) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(newIndex + 1);
      }
    },
  };
  const ScrollCards = [
    // {
    //   url: "joinus-comment-1.png",
    // },
    {
      url: "joinus-comment-2.png",
    },
    {
      url: "joinus-comment-3.png",
    },
    {
      url: "joinus-comment-4.png",
    },
    {
      url: "joinus-comment-5.png",
    },
    {
      url: "joinus-comment-6.png",
    },
    {
      url: "joinus-comment-7.png",
    },
    {
      url: "joinus-comment-8.png",
    },
    {
      url: "joinus-comment-9.png",
    },
    {
      url: "joinus-comment-10.png",
    },
    {
      url: "joinus-comment-11.png",
    },
    {
      url: "joinus-comment-12.png",
    },
    {
      url: "joinus-comment-13.png",
    },
    {
      url: "joinus-comment-14.png",
    },
    {
      url: "joinus-comment-15.png",
    },

    // {
    //   name: t("learn.mfaPage.features.blockOne.item1.title"),
    //   descript: t("learn.mfaPage.features.blockOne.item1.descript"),
    //   icon: "authing-user-3-fill",
    //   keyIndex: 0,
    // },
    // {
    //   name: t("learn.mfaPage.features.blockOne.item2.title"),
    //   descript: t("learn.mfaPage.features.blockOne.item2.descript"),
    //   icon: "authing-fingerprint-line",
    //   keyIndex: 1,
    // },
    // {
    //   name: t("learn.mfaPage.features.blockOne.item3.title"),
    //   descript: t("learn.mfaPage.features.blockOne.item3.descript"),
    //   icon: "authing-map-pin-2-fill",
    //   keyIndex: 2,
    // },
    // {
    //   name: t("learn.mfaPage.features.blockOne.item4.title"),
    //   descript: t("learn.mfaPage.features.blockOne.item4.descript"),
    //   icon: "authing-git-pull-request-line",
    //   keyIndex: 3,
    // },
    // {
    //   name: t("learn.mfaPage.features.blockOne.item5.title"),
    //   descript: t("learn.mfaPage.features.blockOne.item5.descript"),
    //   icon: "authing-bubble-chart-fill",
    //   keyIndex: 4,
    // },
  ];
  return (
    <div className="joinus-experience-scroll">
      <div className="scroll-block">
        <Slider {...settings}>
          {ScrollCards.map((item, index) => {
            const cls = classNames({
              "scroll-block-card": true,
              checked: index === currentIndex,
            });
            return (
              <div>
                <div className={cls}>
                  <div className="scroll-img">
                    <img
                      src={`//files.authing.co/authing-website/${item.url}`}
                      alt="authing"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};
